import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/subscriptionicon.svg'
import _imports_1 from '@/assets/icons/add.svg'
import _imports_2 from '@/assets/icons/addaddonenabled.svg'
import _imports_3 from '@/assets/icons/usericon.svg'
import _imports_4 from '@/assets/icons/active.svg'
import _imports_5 from '@/assets/icons/inactive.svg'


const _hoisted_1 = {
  key: 0,
  class: "font-bold"
}
const _hoisted_2 = {
  key: 1,
  class: "font-regular"
}
const _hoisted_3 = {
  key: 2,
  class: "font-bold header-font"
}
const _hoisted_4 = { class: "titlediv titlestyle" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {"width":"25px"},
    alt: "subscriptioniconimg",
    title: "subscriptioniconimg"
  }),
  /*#__PURE__*/_createTextVNode(" Credential-based license ")
], -1)
const _hoisted_6 = {
  style: {"margin-bottom":"1.5rem"},
  class: "cardtext_font"
}
const _hoisted_7 = { class: "titlediv marginbottom" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Free seats", -1)
const _hoisted_9 = { class: "titlestyle" }
const _hoisted_10 = { class: "assignItemsdiv" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"40px"},
  alt: "Assign Products",
  title: "Click to Assign Products to users"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "cardbuttontext" }, " Assign product", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {"width":"40px"},
  alt: "Assign Add-on",
  title: "Click to Assign Add-ons to users"
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "cardbuttontext",
  "data-cy": "dashboard-label-assignAddOns"
}, " Assign Add-on", -1)
const _hoisted_15 = { class: "titlediv titlestyle" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    style: {"width":"25px"},
    alt: "usericonimg",
    title: "usericonimg"
  }),
  /*#__PURE__*/_createTextVNode(" Users ")
], -1)
const _hoisted_17 = { style: {"margin-bottom":"1.5rem"} }
const _hoisted_18 = { class: "titlediv marginbottom" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    style: {"width":"20px"},
    alt: "activeimg",
    title: "activeimg"
  }),
  /*#__PURE__*/_createTextVNode("     Active users ")
], -1)
const _hoisted_20 = { class: "titlestyle" }
const _hoisted_21 = { class: "titlediv" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    style: {"width":"20px"},
    alt: "inactiveimg",
    title: "inactiveimg"
  }),
  /*#__PURE__*/_createTextVNode("     Inactive users ")
], -1)
const _hoisted_23 = { class: "titlestyle" }
const _hoisted_24 = { class: "cardbuttondiv" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"40px"},
  alt: "Add user",
  title: "Click to invite new users to the system"
}, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "cardbuttontext" }, " Invite new user", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_AssignProductsModal = _resolveComponent("AssignProductsModal")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_AssignMultipleAddonsModal = _resolveComponent("AssignMultipleAddonsModal")!
  const _component_AddUserModal = _resolveComponent("AddUserModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, {
      class: _normalizeClass(_ctx.showHeader ? 'accrow' : 'companyrow')
    }, {
      default: _withCtx(() => [
        (_ctx.showHeader)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_1, "Overview"))
          : _createCommentVNode("", true),
        (_ctx.showHeader)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_2, _toDisplayString(_ctx.currentUserCompany), 1))
          : _createCommentVNode("", true),
        (!_ctx.showHeader)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_3, " Product license & Users "))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 8,
          offset: 0
        }, {
          default: _withCtx(() => [
            (_ctx.subInfo !== '')
              ? (_openBlock(), _createBlock(_component_el_card, {
                  key: 0,
                  class: "box-card"
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _hoisted_5,
                      _createElementVNode("label", null, _toDisplayString(_ctx.subInfo), 1)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.subfreeSeats), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_el_button, {
                          plain: "",
                          variant: "light",
                          class: "doptbtn",
                          onClick: _ctx.showAddProducts,
                          id: "assignProducts",
                          "data-cy": "dashboard-button-assignProducts"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _hoisted_12
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_el_button, {
                          plain: "",
                          variant: "light",
                          class: "doptbtn",
                          onClick: _ctx.showAssignAddOns,
                          id: "assignAddOns",
                          "data-cy": "dashboard-button-assignAddOns"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_13
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _hoisted_14
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 8,
          offset: 1
        }, {
          default: _withCtx(() => [
            (_ctx.userInfo !== '')
              ? (_openBlock(), _createBlock(_component_el_card, {
                  key: 0,
                  class: "box-card"
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("label", null, _toDisplayString(_ctx.usersTotal), 1)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.usersActive), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.usersInactive), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_el_button, {
                        plain: "",
                        variant: "light",
                        class: "doptbtn",
                        onClick: _ctx.assignUsers,
                        id: "adduser"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_25
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _hoisted_26
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.showAddprod,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showAddprod) = $event)),
      direction: "rtl",
      size: "40%",
      "destroy-on-close": "",
      "before-close": _ctx.closeModal,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AssignProductsModal)
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.showAssignAddonExclusive,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showAssignAddonExclusive) = $event)),
      direction: "rtl",
      size: "40%",
      "destroy-on-close": "",
      "before-close": _ctx.closeModal,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AssignMultipleAddonsModal)
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.showAdduser,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showAdduser) = $event)),
      direction: "rtl",
      size: "40%",
      "destroy-on-close": "",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "before-close": _ctx.closeModal
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AddUserModal, { showheading: true })
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"])
  ], 64))
}